import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getPosts } from "../../redux/actionCreators/postsActionCreator";
import PostCard from "./PostCard";

const Posts = () => {
  const { postsLoading, allPosts, userId } = useSelector(
    (state) => ({
      postsLoading: state.posts.postsLoading,
      allPosts: state.posts.posts,
      userId: state.auth.userId,
    }),
    shallowEqual
  );
  const dispatch = useDispatch();
  // console.log(allPosts);
  const posts = allPosts.filter((post) => post.post.author === userId && post);
  useEffect(() => {
    
      dispatch(getPosts());
    
  }, [dispatch]);
  return (
    <div className="container-fluid" style={{minHeight: "750px"}}>
      <div className="row">
        <div className="col-md-12 mb-3">
          <Link to="/admin/dashboard/addPost" className="btn float-right mt-5" style={{backgroundColor: "#1AC5D9", borderRadius: "100px", color: "white", marginRight: "12rem", fontSize: "20px"}}>
            Create
          </Link>
          <h6 className="display-4 text-dark text-left mt-5 mb-2" style={{marginLeft: "180px", fontSize: "38px"}}>All Ads</h6>
        </div>
      </div>
      <div className="row d-flex align-items-center justify-content-center">
        {postsLoading ? (
          <h1 className="text-center">Loading Ads...</h1>
        ) : posts.length > 0 ? (
          <>
            {posts.map((post, id) => (
              <PostCard post={post} key={id} id={id} />
            ))}
          </>
        ) : (
          <h3 className="text-center">
            You haven't created any Ad{" "}
            <Link to="/admin/dashboard/addPost" className="ml-2">
              Create Ad
            </Link>
          </h3>
        )}
      </div>
    </div>
  );
};

export default Posts;
